import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessoAbasService } from '../services/processo-abas.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessoAbasResolver implements Resolve<boolean> {
  constructor(private service: ProcessoAbasService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProcessoAbasTiposResolver implements Resolve<boolean> {
  constructor(private service: ProcessoAbasService) {}

  resolve(): Observable<any> {
    return this.service.getTiposList();
  }
}
